import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root',
})

export class OperationRentalService {
  private baseURL: string;
  constructor(private http: HttpClient) {
    this.baseURL = environment.apiBaseUrl;
  }

  public options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

  getRecordFromTemp(): Observable<any[]> {
    return this.http.get<any[]>(
      `${this.baseURL}/Rental/GetRecordFromTemp`,
      { observe: 'response' })
      .pipe(
        map(res => {
          return res.body as any;
        }),
        catchError(this.handleError)
      );
  }

  deleteFromTemp(tempData): Observable<any> {
    const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    const url = `${this.baseURL}/Rental/DeleteFromTemp`;
    if (tempData.StartDate != undefined) {
      const timezoneOffset = tempData.StartDate.getTimezoneOffset();
      const adjustedDate = new Date(tempData.StartDate.getTime() - (timezoneOffset * 60000));
      tempData.StartDate = adjustedDate.toISOString();
    }
    return this.http.post<any>(url, tempData, options)
      .pipe(
        map(res => {
          const response = res as any[];
          return response;
        }),
        catchError(this.handleError)
      );
  }

  deleteCombinedMonthlyReservation(rentalData): Observable<any> {
    const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    const url = `${this.baseURL}/Rental/DeleteCombinedMonthlyReservation`;
    return this.http.post<any>(url, rentalData, options)
      .pipe(
        map(res => {
          const response = res as any[];
          return response;
        }),
        catchError(this.handleError)
      );
  }

  insertDataToTemp(tempData): Observable<any> {
    const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    const url = `${this.baseURL}/Rental/InsertDataToTemp`;
    if (tempData.length > 0) {
      for (var item of tempData) {
        if (item.StartDate) {
          const timezoneOffset = item.StartDate.getTimezoneOffset();
          const adjustedDate = new Date(item.StartDate.getTime() - (timezoneOffset * 60000));
          item.StartDate = adjustedDate.toISOString();
        }
      }
    }
    return this.http.post<any>(url, tempData, options)
      .pipe(
        map(res => {
          const response = res as any[];
          return response;
        }),
        catchError(this.handleError)
      );
  }

  getProductCategories(): Observable<any[]> {
    return this.http.get<any[]>(
      `${this.baseURL}/ProductCategory/GetMarketProductCategory`,
      { observe: 'response' })
      .pipe(
        map(res => {
          return res.body as any;
        }),
        catchError(this.handleError)
      );
  }

  getRentalSettings(): Observable<any> {
    return this.http.get<any>(
      `${this.baseURL}/Rental/GetSettingsForRentals`,
      { observe: 'response' })
      .pipe(
        map(res => {
          return res.body as any;
        }),
        catchError(this.handleError)
      );
  }

  getAllBoothsForDailyRentalTypeLayout(partId, selectedMarketDays): Observable<any> {
    const url = `${this.baseURL}/Rental/GetAllBoothsForDailyRentalTypeLayout?partId=` + partId
    return this.http.post<any>(url, selectedMarketDays, this.options)
      .pipe(
        map(res => {
          const response = res as any;
          return response;
        }),
        catchError(this.handleError)
      );
  }

  getALLBoothsForLayoutALLRentalTypes(rentalTypesDatesModel): Observable<any> {
    const url = `${this.baseURL}/Rental/GetALLBoothsForLayoutALLRentalTypes`
    return this.http.post<any>(url, rentalTypesDatesModel, this.options)
      .pipe(
        map(res => {
          const response = res as any;
          return response;
        }),
        catchError(this.handleError)
      );
  }

  generateTempRecordNumber(): Observable<any> {
    return this.http.get<any>(
      `${this.baseURL}/Rental/GenerateTempRecordNumber`,
      { observe: 'response' })
      .pipe(
        map(res => {
          return res.body as any;
        }),
        catchError(this.handleError)
      );
  }

  getMonthlyMarketDays(): Observable<any[]> {
    return this.http.get<any[]>(
      `${this.baseURL}/Rental/GetMonthlyMarketDays`,
      { observe: 'response' })
      .pipe(
        map(res => {
          return res.body as any;
        }),
        catchError(this.handleError)
      );
  }

  getMonthlyBookings(vendorId): Observable<any[]> {
    return this.http.get<any[]>(
      `${this.baseURL}/Rental/GetCombinedMonthlyBookings?vendorId=` + vendorId,
      { observe: 'response' })
      .pipe(
        map(res => {
          return res.body as any;
        }),
        catchError(this.handleError)
      );
  }

  getBoothRentalMonthlyCharges(monthlyRentalCharges): Observable<any> {
    const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    const url = `${this.baseURL}/Rental/getBoothRentalMonthlyCharges`;
    return this.http.post<any>(url, monthlyRentalCharges, options)
      .pipe(
        map(res => {
          const response = res as any[];
          return response;
        }),
        catchError(this.handleError)
      );
  }

  GetCombinedMonthlyOtherRentals(vendorId): Observable<any[]> {
    return this.http.get<any[]>(
      `${this.baseURL}/Rental/GetCombinedMonthlyOtherRentals?vendorId=` + vendorId,
      { observe: 'response' })
      .pipe(
        map(res => {
          return res.body as any;
        }),
        catchError(this.handleError)
      );
  }

  getBoothRentalCombinedMonthlyCharges(cmonthlyRentalCharges): Observable<any> {
    const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    const url = `${this.baseURL}/Rental/GetBoothRentalCombinedMonthlyCharges`;
    return this.http.post<any>(url, cmonthlyRentalCharges, options)
      .pipe(
        map(res => {
          const response = res as any[];
          return response;
        }),
        catchError(this.handleError)
      );
  }

  getAvailableBoothsForCombinedMonthly(selectedDates): Observable<any> {
    const url = `${this.baseURL}/Rental/GetAvailableBoothsForCombinedMonthly`;
    return this.http.post<any>(url, selectedDates, this.options)
      .pipe(
        map(res => {
          const response = res as any;
          return response;
        }),
        catchError(this.handleError)
      );
  }

  getOtherRentalItems(): Observable<any[]> {
    return this.http.get<any>(
      `${this.baseURL}/Rental/GetOtherRentalItems`,
      { observe: 'response' })
      .pipe(
        map(res => {
          return res.body as any;
        }),
        catchError(this.handleError)
      );
  }

  getOtherItemsRentalCharges(otherRentalCharges): Observable<any> {
    const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    const url = `${this.baseURL}/Rental/GetOtherItemsRentalCharges`;
    return this.http.post<any>(url, otherRentalCharges, options)
      .pipe(
        map(res => {
          const response = res as any[];
          return response;
        }),
        catchError(this.handleError)
      );
  }

  getAvailableBoothsForMonthly(selectedDates): Observable<any> {
    const url = `${this.baseURL}/Rental/getAvailableBoothsForMonthly`;
    return this.http.post<any>(url, selectedDates, this.options)
      .pipe(
        map(res => {
          const response = res as any;
          return response;
        }),
        catchError(this.handleError)
      );
  }

  saveCombinedMonthlyRental(rentalData): Observable<any> {
    const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    const url = `${this.baseURL}/Rental/SaveCombinedMonthlyRentalTransactions`;
    return this.http.post<any>(url, rentalData, options)
      .pipe(
        map(res => {
          const response = res as any[];
          return response;
        }),
        catchError(this.handleError)
      );
  }

  saveVendorRentalDues(rentalPaymentModel): Observable<any> {
    const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    const url = `${this.baseURL}/Rental/SaveVendorRentalDues`;
    return this.http.post<any>(url, rentalPaymentModel, options)
      .pipe(
        map(res => {
          const response = res as any[];
          return response;
        }),
        catchError(this.handleError)
      );
  }

  checkRentalExits(rentalDateDetails): Observable<boolean> {
    const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    const url = `${this.baseURL}/Rental/CheckRentalExits`;
    return this.http.post<any>(url, rentalDateDetails, options)
      .pipe(
        map(res => {
          const response = res as boolean;
          return response;
        }),
        catchError(this.handleError)
      );
  }

  getCombinedMonthlyBookings(vendorId): Observable<any[]> {
    return this.http.get<any[]>(
      `${this.baseURL}/Rental/GetCombinedMonthlyBookings?vendorId=` + vendorId,
      { observe: 'response' })
      .pipe(
        map(res => {
          return res.body as any;
        }),
        catchError(this.handleError)
      );
  }

  getVendorRentalDues(vendorId): Observable<any[]> {
    return this.http.get<any>(
      `${this.baseURL}/Rental/GetVendorRentalDues?VendorId=${vendorId}`,
      { observe: 'response' })
      .pipe(
        map(res => {
          return res.body as any;
        }),
        catchError(this.handleError)
      );
  }

  deleteCombinedMonthlyOtherItemReservation(rentalData): Observable<any> {
    const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    const url = `${this.baseURL}/Rental/DeleteCombinedMonthlyOtherItemReservation`;
    return this.http.post<any>(url, rentalData, options)
      .pipe(
        map(res => {
          const response = res as any[];
          return response;
        }),
        catchError(this.handleError)
      );
  }

  getRentalDepositSlipByDate(date: string): Observable<any> {
    const url = `${this.baseURL}/Rental/GetRentalDepositSlipByDate?date=${encodeURIComponent(date)}`;
    return this.http.get<any>(url, { observe: 'response' })
      .pipe(
        map(res => res.body as any),
        catchError(this.handleError)
      );
  }

  getRentalDepositSlipByRange(fromId: number, toId: number): Observable<any> {
    const url = `${this.baseURL}/Rental/GetRentalDepositSlipByRange?fromId=${fromId}&toId=${toId}`;
    return this.http.get<any>(url, { observe: 'response' })
      .pipe(
        map(res => res.body as any),
        catchError(this.handleError)
      );
  }

   getDefaultMarketId(): Observable<any> {
    return this.http.get<any>(
      `${this.baseURL}/User/GetDefaultMarketId`,
      { observe: 'response' })
      .pipe(
        map(res => {
          return res.body as any;
        }),
        catchError(this.handleError)
      );

    }

  generatePaymentReceipt(paymentReceiptData): Observable<any> {
    const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    const url = `${this.baseURL}/PaymentReceipt/GeneratePaymentReceipt`;
    return this.http.post<any>(url, paymentReceiptData, options)
      .pipe(
        map(res => {
          const response = res as any;
          return response;
        }),
        catchError(this.handleError)
      );
  }

  getDefaultRentalNotes(): Observable<string> {
    return this.http.get(
      `${this.baseURL}/Rental/GetDefaultRentalNotes`,
      { responseType: 'text' }
    ).pipe(
      map(res => res as string),
      catchError(this.handleError)
    );
  }

  getVendorBoothCredit(vendorId): Observable<any> {
    return this.http.get<any[]>(
      `${this.baseURL}/Rental/GetVendorBoothCredit?vendorId=` + vendorId,
      { observe: 'response' })
      .pipe(
        map(res => {
          return res.body as any;
        }),
        catchError(this.handleError)
      );
  }

  private handleError(error: HttpErrorResponse) {
    console.error('server error:', error);
    if (error.error instanceof Error) {
      const errMessage = error.error.message;
      return throwError(errMessage);
    }
    return throwError(error || 'Node.js server error');
  }
}